<template>
  <v-container class="ma-0">
    <v-layout row>
      <v-flex>
        <div class="d-flex ">
          <div class="perma-section-input pl-2">{{input}}</div>
          <div>
            <v-btn
              class="ex-remove-btn w-100 ma-0 mb-2"
              @click="remove()"
              color="error"
              dark
              large
            >Remove Chain</v-btn>
            <div class="perma-section text-center pt-3 pb-3">{{method}}</div>
            <div class="page selector_chainlink">
              <div>
                <span class="label">Page Object</span>
                <v-btn
                  v-show="!html.variableBlock"
                  @click="addVariable()"
                >Add Var</v-btn>
                <div v-show="html.variableBlock">
                  <v-text-field
                    v-model="html.container.variableName"
                    placeholder="variable name"
                  />
                  <v-text-field
                    v-model="html.container.variableValue"
                    placeholder="variable value"
                  />
                  <v-btn @click="closeVariable()">Close</v-btn>
                  <v-btn @click="saveVariable()">Save</v-btn>
                </div>
              </div>
              <div
                class="col"
                v-show="result.length > 0"
              >{{result}}</div>
            </div>
            <v-btn
              class="ex-add-btn  w-100 ma-0 mt-2"
              @click="add()"
              color="success"
              dark
              large
            >Add Chain</v-btn>
          </div>
          <div class="perma-section-output pr-2">{{output}}</div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import { AppUrl } from '../../assets/js/variables'
import JwtService from '@/assets/js/JwtService'

export default {
  name: 'pageBlock',
  props: ['x', 'y', 'variables'],
  data: () => ({
    destroy: false,
    seller_id: null,
    html: {
      variableBlock: false,
      container: {
        variableName: '',
        variableValue: ''
      }
    },
    result: '',
    input: '',
    method: '',
    output: 'pageBlock',
    customVarz: [],
    options: {
      variables: { options: [] }
    }
  }),
  methods: {
    addGlobalVars () {
      this.$emit('addGlobalVars', this.y, this.x, this.options.variables.options)
    },
    getBlockVars () {
      const self = this
      console.log(this.seller_id)
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      axios.post(AppUrl, {
        task: 'getOptions',
        payload: {
          'chain': 'pageBlock',
          'seller_id': self.seller_id
        }
      }, params).then(function (response) {
        if (self.options.variables.options.length === 0) {
          let data = response.data
          self.$set(self.options.variables, 'options', data.outputs.variables)
          self.addGlobalVars()
          console.log(data.outputs.variables)
        }
      })
    },
    addVariable () {
      this.html.variableBlock = true
    },
    closeVariable () {
      this.html.variableBlock = false
    },
    saveVariable () {
      this.options.variables.options.push({ id: this.html.container.variableName, value: this.html.container.variableValue })
      this.addGlobalVars()
      this.html.container.variableName = ''
      this.html.container.variableValue = ''
      this.html.variableBlock = false
    },
    add () {
      console.log('open component add')
      this.$emit('add', this.y, this.x)
    }
  },
  mounted: function () {
    var result = this.variables.filter(obj => {
      return (obj.id === 'main_sellerId')
    })
    if (result.length > 0) {
      this.seller_id = result[0].value
    }
    this.getBlockVars()
  },
  computed: {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selector/Page.vue